import React from "react";
import PropTypes from "prop-types";

import SFTypography from "../typography";
import getStyled from "../../hooks/getStyled";
import styles from "../../theme/styles";

const { styled } = getStyled();

const HeaderWrapper = styled("div")(({ hasActionButtons }) => ({
  display: hasActionButtons ? "flex" : "block",
  justifyContent: "space-between",
  "& .action-buttons": {
    float: "right",
    paddingTop: "3px",
    "& button": {
      padding: "7px",
      marginLeft: "7px",
    },
  },
}));

const SFHeading = ({
  gutterTop = false,
  gutterBottom = false,
  gutterBoth = false,
  title = "",
  align = "inherit",
  variant = "h1",
  component = null,
  noWrap = false,
  paragraph = false,
  sx = null,
  styleIcon = {},
  icon,
  actionButtons = null,
  ...props
}) => {
  const filteredBtns = actionButtons ? actionButtons.filter((btn) => btn) : [];
  let customStyles = {};

  if (gutterBoth) {
    customStyles.marginTop = 16;
    customStyles.marginBottom = 16;
  }

  if (gutterBottom) {
    customStyles.marginBottom = 16;
  }

  if (gutterTop) {
    customStyles.marginTop = 16;
  }

  return (
    <HeaderWrapper
      hasActionButtons={filteredBtns.length > 0}
      style={customStyles}
    >
      <SFTypography
        noWrap={noWrap}
        align={align}
        variant={variant}
        sx={sx}
        component={component}
      >
        {icon && (
          <div style={{ float: "left", marginRight: 10, ...styleIcon }}>
            {icon}
          </div>
        )}
        {title || props.children}
      </SFTypography>

      {filteredBtns.length > 0 && (
        <div className="action-buttons">
          {filteredBtns.map((btn, index) => (
            <React.Fragment key={index}>{btn}</React.Fragment>
          ))}
        </div>
      )}
    </HeaderWrapper>
  );
};

SFHeading.propTypes = {
  gutterBottom: PropTypes.bool,
  variant: PropTypes.oneOf(Object.keys(styles)),
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  title: PropTypes.string,
  actionButtons: PropTypes.arrayOf(PropTypes.node),
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.bool]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default SFHeading;
